export async function copyToClipboard(text) {
  try { await navigator.clipboard.writeText(text); return true; }
  catch {
    const el = document.createElement('textarea'); el.value = text;
    Object.assign(el.style, { position:'fixed', opacity:'0' });
    document.body.appendChild(el); el.select();
    document.execCommand('copy'); document.body.removeChild(el); return true;
  }
}
